import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import classnames from 'classnames';
import { range } from 'lodash';
import PropTypes from 'prop-types';
import { withViewportMatch } from '@wordpress/viewport';
/**
 * Internal dependencies
 */

import { getHasItemsClass } from './utils';
/**
 * `SummaryListPlaceholder` behaves like `SummaryList` but displays placeholder summary items instead of data.
 * This can be used while loading data.
 */

var SummaryListPlaceholder =
/*#__PURE__*/
function (_Component) {
  _inherits(SummaryListPlaceholder, _Component);

  function SummaryListPlaceholder() {
    _classCallCheck(this, SummaryListPlaceholder);

    return _possibleConstructorReturn(this, _getPrototypeOf(SummaryListPlaceholder).apply(this, arguments));
  }

  _createClass(SummaryListPlaceholder, [{
    key: "render",
    value: function render() {
      var _classnames;

      var isDropdownBreakpoint = this.props.isDropdownBreakpoint;
      var numberOfItems = isDropdownBreakpoint ? 1 : this.props.numberOfItems;
      var hasItemsClass = getHasItemsClass(numberOfItems);
      var classes = classnames('woocommerce-summary', (_classnames = {}, _defineProperty(_classnames, hasItemsClass, !isDropdownBreakpoint), _defineProperty(_classnames, 'is-placeholder', true), _classnames));
      var rows = range(numberOfItems).map(function (i) {
        return createElement("li", {
          className: "woocommerce-summary__item-container is-placeholder",
          key: i
        }, createElement("span", {
          className: "woocommerce-summary__item"
        }, createElement("span", {
          className: "woocommerce-summary__item-label"
        }), createElement("span", {
          className: "woocommerce-summary__item-data"
        }, createElement("span", {
          className: "woocommerce-summary__item-value"
        }), createElement("div", {
          className: "woocommerce-summary__item-delta"
        }, createElement("span", {
          className: "woocommerce-summary__item-delta-value"
        }))), createElement("span", {
          className: "woocommerce-summary__item-prev-label"
        }), createElement("span", {
          className: "woocommerce-summary__item-prev-value"
        })));
      });
      return createElement("ul", {
        className: classes,
        "aria-hidden": "true"
      }, rows);
    }
  }]);

  return SummaryListPlaceholder;
}(Component);

SummaryListPlaceholder.propTypes = {
  /**
   * An integer with the number of summary items to display.
   */
  numberOfItems: PropTypes.number.isRequired
};
SummaryListPlaceholder.defaultProps = {
  numberOfRows: 5
};
export default withViewportMatch({
  isDropdownBreakpoint: '< large'
})(SummaryListPlaceholder);
//# sourceMappingURL=placeholder.js.map